import {Http, URLSearchParams, RequestOptions} from '@angular/http';
import {IDataModel} from "../../services/IDataModel";
import {IDataFilter} from "../../services/DataTable";
import {CompaniesModel} from "./companies.model";
import {Observable} from "rxjs/Rx";
import {ListResponseModel, ResponseModel} from "../response/response.model";
import {Injectable} from "@angular/core";

@Injectable()
export class CompaniesService implements IDataModel {

    private API_ROOT:string = '/companies';

    constructor(private http: Http) {}

    getList(filter?: IDataFilter) : Observable<ListResponseModel<CompaniesModel>> {
        let params: URLSearchParams = new URLSearchParams();
        if (filter) {
            for(let key in filter) {
                params.set(key, filter[key]);
            }
        }

        return this.http
            .get(this.API_ROOT, new RequestOptions({
                search: params
            }))
            .map((res) => res.json());
    }

    getOne(id: number) : Observable<ResponseModel<CompaniesModel>> {
        return this.http.get(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }

    add (fields: CompaniesModel): Observable<ResponseModel<CompaniesModel>> {
        return this.http.post(this.API_ROOT, fields).map((res) => res.json());
    }

    edit (id: number, fields: CompaniesModel): Observable<ResponseModel<CompaniesModel>> {
        return this.http.put(`${this.API_ROOT}/${id}`, fields).map((res) => res.json());
    }

    remove(id: number) {
        return this.http.delete(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }

}


// WEBPACK FOOTER //
// ./src/app/models/companies/companies.service.ts